/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type HTMLAttributes, createContext, forwardRef, useContext } from 'react';
import { useHover } from 'react-aria';
import { $ } from '../../tokens.stylex';

interface MentionContextValue {
  isOwn?: boolean;
}

interface MentionProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'className' | 'style'> {
  isOwn?: boolean;
  style?: stylex.StyleXStyles;
}

const MentionContext = createContext<MentionProps | null>(null);

const Mention = forwardRef((props: MentionProps, ref: ForwardedRef<HTMLSpanElement>) => {
  const ctx = useContext(MentionContext);
  const { isOwn = false, style, children, ...otherProps } = { ...ctx, ...props };

  const variant = isOwn ? 'sent' : 'received';
  const { hoverProps, isHovered } = useHover({});

  return (
    <span
      ref={ref}
      {...hoverProps}
      {...(isHovered ? { 'data-hovered': true } : {})}
      {...otherProps}
      {...stylex.props(styles.base, variantVariants[variant], style)}>
      {children}
    </span>
  );
});

const styles = stylex.create({
  base: {
    borderRadius: 4,
    paddingInline: 2,
    display: 'inline',
    fontFamily: 'Inter, sans-serif',
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: '-0.03125em',
    lineHeight: '1.25em',
  },
});

const variantVariants = stylex.create({
  received: {
    backgroundColor: {
      default: $.surfaceHighlightSilent,
      ':is([data-hovered])': $.surfaceHighlightMedium,
    },
    color: $.textInteractive,
  },
  sent: {
    backgroundColor: {
      default: $.opacity10Inverted,
      ':is([data-hovered])': $.opacity32Inverted,
    },
    color: $.textInverted,
  },
});

export { Mention, MentionContext, type MentionContextValue, type MentionProps };
